module.exports = __webpack_public_path__ + "img/51.44bb39d2.png";